import { PAGE_ROUTES_WITHOUT_LAYOUT } from '@/shared/constants/next';

const COMPONENT_PLAYGROUND_ROUTE = /^\/pages\/components(?:\/|$)/;

export const isComponentPlaygroundRoute = (route: string) =>
  COMPONENT_PLAYGROUND_ROUTE.test(route);

export const usesPageLayout = (route: string) =>
  !isComponentPlaygroundRoute(route) &&
  !route.startsWith('/private/') &&
  !PAGE_ROUTES_WITHOUT_LAYOUT.has(route);

export const shouldApplyPageHeaderOffset = usesPageLayout;

export const shouldFetchAppCsrf = (route: string, isMobileApp: boolean) =>
  isMobileApp && !isComponentPlaygroundRoute(route);
